import { fork, takeEvery } from 'redux-saga/effects'

function* onLocationChangeSaga() {
  yield fork(window.scrollTo, 0, 0)
}

export default function* routerSaga() {
  yield takeEvery('@@router/LOCATION_CHANGE', onLocationChangeSaga)
}
